export default __webpack_public_path__ + "ruby-18dc7ba9d0c63eb694c72d5452f86176.png";